import { render, staticRenderFns } from "./quotationAdd.vue?vue&type=template&id=2d7ec3c4&scoped=true"
import script from "./quotationAdd.vue?vue&type=script&lang=js"
export * from "./quotationAdd.vue?vue&type=script&lang=js"
import style0 from "./quotationAdd.vue?vue&type=style&index=0&id=2d7ec3c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ec3c4",
  null
  
)

export default component.exports